
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import Nav from "@/components/Nav";
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'

let vm = null;
export default {
name: "index",
data() {
return {

swiperOption: {
loop: false,
autoplay: true,
speed: 3000,
disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
initialSlide: 0,
observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化swiper
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev"
},
pagination: { el: ".swiper-pagination" }
},
abroadOption: {
loop: false,
autoplay: true,
speed: 3000,
disableOnInteraction: true, //用户操作swiper之后，是否禁止autoplay。
initialSlide: 0,
observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化swiper
navigation: {
nextEl: ".swiper-button-next",
prevEl: ".swiper-button-prev"
},
pagination: { el: ".swiper-pagination" }
},
graduteOption: {
direction: "vertical",
slidesPerView: 3,
loop: true,
autoplay: {
delay: 0,
disableOnInteraction: false
},
speed: 4000,

preventClicks: false,
preventLinksPropagation: false,

initialSlide: 0,

observer: true, //修改swiper自己或子元素时，自动初始化swiper
observeParents: true, //修改swiper的父元素时，自动初始化
on: {
click: function() {




const realIndex = this.clickedSlide.attributes["data-idx"]
.nodeValue;
console.log(
realIndex,
this.clickedIndex,
"realIndex",
vm.homeData.graduates[realIndex].name
);
vm.handleClickSlide(realIndex);
}
}
},
homeData: {
videos: [],
article_about: [],
article_infos: [],
article_services: [],
article_event_teaser: [],
article_event_review: [],
graduates: []
},
bririshId: "",
ontarioId: "",
list: [],
playing: false,
graduateIndex: 0 
};
},
directives: {
TransferDom
},
components: {
swiper,
swiperSlide,
Nav,
Previewer
},
computed: {
swiper() {
return this.$refs.mySwiper.swiper;
}
},
created() {
vm = this;
this.getSearchOptions();
this.getData();
},
mounted() {
let that = this;
this.swiper.on("slideChange", function() {
for (var i = 0; i < that.homeData.videos.length; i++) {
var myVideo = "myVideo" + i;
var x = document.getElementById(myVideo);
x.pause();
that.playing = false;
}
});
},
methods: {
handleClickSlide(index) {
if (this.graduateIndex == 0) {




this.$refs.previewer.show(index);
} else if (this.graduateIndex == 1) {
if (this.homeData.graduates[index].school_url) {
window.location.href = this.homeData.graduates[index].school_url;
}
} else {
if (this.homeData.graduates[index].university_url) {
window.location.href = this.homeData.graduates[index].university_url;
}
}
},
logIndexChange(arg) {
console.log(arg);
},
show(index) {
this.graduateIndex = 0;

},
goSchool(id) {
this.$router.push({
name: "school",
query: {
id: id
}
});
},
goDetails(item) {
if (item.url) {
window.location.href = item.url;
} else {
this.$router.push({
name: "popdetais",
query: {
id: item.id
}
});
}
},

goService(id) {
this.$router.push({
name: "Allservices",
query: {
id: id
}
});
},

goOverseas() {
this.$router.push({
name: "Overseas"
});
},

goGraduation() {
this.$router.push({
name: "Graduation"
});
},

goHomedata() {
this.$router.push({
name: "Popularactivities"
});
},
jump(url, index) {
this.graduateIndex = index;



},
getData() {
this.$api.getHome().then(res => {
if (res.data.success && res.data.code == 0) {
let data = res.data.data;
this.homeData = data;
data.graduates.map(val => {
this.list.push({
src: val.image
});
});
console.log(data);
} else {
this.$vux.toast.text(res.data.message, "middle");
}
});
},
play() {
this.swiper.autoplay.stop();
this.playing = true;
console.log("点击了播放", this.swiper.params.autoplay);
},
end() {
console.log("播放结束");
this.swiper.autoplay.start();
this.playing = false;
},
getSearchOptions() {
this.$api.getSearchOptions().then(res => {
if (res.data.success && res.data.code == 0) {
let data = res.data.data;
data.addresses.map(val => {
if (val.title.includes("卑诗省")) {
this.bririshId = val.id;
} else if (val.title.includes("安大略省")) {
this.ontarioId = val.id;
}
});
} else {
this.$vux.toast.text(res.data.message, "middle");
}
});
},
}
};



// WEBPACK FOOTER //
// ./src/pages/index.vue